﻿export class WidthBasedPricing {
    minWidth: number;
    maxWidth: number;
    price: number;
}
